@if(tableConfig) {
<div class="marginTop-xl marginBottom-xl">
  <vy-table
    [dataSource]="tableConfig"
    [cellTemplateArrayRef]="{
        recordLocatorInfo: { template: recordLocatorTemplate },
        route: {template: routeTemplate, },
        departureDate: {template: dateTemplate},
        returnDate: {template: dateTemplate},
        passengerCount: { template: defaultTemplate},
        amount: {template: defaultTemplate},
        status:  {template: badgeTemplate}
    }"
    class="table"
    (sort)="onSort($event)"
  ></vy-table>
</div>
}

<ng-template let-item #recordLocatorTemplate>
  <div>
    <span
      markdown
      (click)="goToBookingDetails(item.row.recordLocator)"
      (keypress)="goToBookingDetails(item.row.recordLocator)"
    >
      <a> {{ item.row.recordLocator }} </a>
    </span>
    @if (item.row.gdsRecordLocator) {
    <span> GDS: {{ item.row.gdsRecordLocator }}</span>
    } @if (item.row.channelType === ChannelType.TTOO) {
    <span> TTOO </span>
    }
  </div>
</ng-template>

<ng-template let-item #routeTemplate>
  @if (item.row) {
  <p>
    <markdown>{{item.row | translate}}</markdown>
  </p>
  }
</ng-template>

<ng-template let-item #dateTemplate>
  <p>
    <markdown>{{item.row | date: 'dd/MM/yyyy' }}</markdown>
  </p>
</ng-template>

<ng-template let-item #defaultTemplate>
  <p>
    <markdown>{{item.row}}</markdown>
  </p>
</ng-template>

<ng-template let-item #badgeTemplate>
  @if (item.row) {
  <div>
    <vy-badge
      [badgeText]="getBookingStatusBadgeLabel(item) | translate"
      [variant]="getBookingStatusBadgeVariant(item)"
      [type]="BadgeType.NEGATIVE"
    ></vy-badge>
  </div>
  }
</ng-template>
